<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-1">
          <h1>Caja </h1>
        </div>
        <div class="col-sm-7">
          <div class="input-group mb-4" v-on:keyup.enter="listarPedido(1,fechaBuscar,numBuscar)">
            <div class="input-group-append">
                  <button type="submit" class="btn btn-md btn-default">
                      Fecha venta &nbsp;&nbsp;
                  </button>
            </div>
            <input type="date" v-model="fechaBuscar" class="form-control form-control-md">
            <div class="input-group-append">
              <button type="submit" class="btn btn-md btn-default">
                  N° de Pedido
              </button>
            </div>
            <input type="number" v-model="numBuscar" class="form-control form-control-md" autofocus>
        <div class="input-group-append">
            <button type="submit" class="btn  btn-info" @click="listarPedido(1,fechaBuscar,numBuscar)">
                <i class="fa fa-search"></i> Buscar
            </button>
        </div>
        <div class="input-group-append">
          <button class="btn btn-danger btn-block" @click="limpiarTodo()">Borrar</button>
            </div>
        </div>
        </div>
        <!-- /.col -->
        <div class="col-sm-4">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">Caja</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

<div class="card card-primary card-outline">
  <div class="card-body">
    <div class="row">
        <div class="col-md-9">
            <div class="row">
                <div class="col-md-6">
                  <h3>Pedido: N° {{ numPedido }} &nbsp;&nbsp;&nbsp;&nbsp; <span style="font-size: 12pt;"> Vendedor: {{vendedor}}</span></h3>
                </div>
                <div class="col-md-6">
                  <h3 v-if="fechaPedido" class="text-right">{{ fechaFormateada(fechaPedido) }}</h3>
                </div>
              </div>
            <div class="table-responsive">
                <table class="table table-sm table-striped table-bordered">
                    <thead class="bg-warning">
                        <tr>
                            <th>Producto</th>
                            <th>Descripción</th>
                            <th>Cantidad</th>
                            <th>Precio S/</th>
                            <th>Descuento %</th>
                            <th class="text-right">Importe S/</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="de in arrayDetalle" :key="de.id">
                            <td>{{ de.producto }}</td>
                            <td>{{ de.umVenta }}</td>
                            <td>{{ de.cantidad }}</td>
                            <td>{{ de.precio }}</td>
                            <td>{{ de.descuento }} %</td>
                            <td class="text-right">{{ formattedTotal(de.importe) }}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
        </div>
      <div class="col-sm-3">
        <div class="card">
          <div class="card-header bg-info">Datos de venta</div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">Nombre del Cliente:</label>
                  <input type="text" class="form-control bg-dark-subtle" :class="cliente?'is-valid':''" :value="cliente" disabled>
                </div>
              </div>
              <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputEmail1">N° Documento del Cliente:</label>
                <input type="text" class="form-control bg-dark-subtle" :class="cliente_doc?'is-valid':''" :value="cliente_doc" disabled>
              </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">Direccion del Cliente:</label>
                  <input type="text" class="form-control bg-dark-subtle" :class="cliente_doc?'is-valid':''" :value="cliente_dir" disabled>
                </div>
              </div>
            </div>
        

         
            <div class="input-group mb-4" >
                <div class="input-group-append">
                    <button type="submit" class="btn btn-md btn-default">
                        C.
                    </button>
                </div>
                <input type="text" :class="{'is-valid':comprobante}" :value="comprobante" class="form-control form-control-md bg-white" readonly>
            </div>

            <div class="input-group mb-4" >
        
            <div class="input-group-append">
                <button type="submit" class="btn btn-md btn-default">
                    N°
                </button>
            </div>
            <input type="text" class="form-control form-control-md bg-white" readonly :value="serie+'-'+numComprobante" :class="{'is-valid':ventactivo}">
            </div>
              
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div class="row mt-2">
            <div class="col-md-3">
              IGV
              <input type="text" class="form-control  " readonly :value="igvTotal">
            </div>
            <div class="col-md-3">
              DSCTO
              <input type="text" class="form-control  " readonly :value="dsctoTotal">
            </div>
            <div class="col-md-3">
              SUB TOTAL
                <input type="text" class="form-control " readonly :value="subtotal">
            </div>
            <div class="col-md-3">
                METODO DE PAGO
                <select class="form-control" v-model="metpago" :disabled="ventactivo?true:false">
                    <option :value="0">=== Seleccione ===</option>
                    <option v-for="pago in arraymetodopago" :key="pago.id" :value="pago">{{pago}}</option>
                </select>
            </div>
          </div>
      </div>
      <div class="col-md-3">
        <div class="row">                      
            <div class="col-md-12" style="text-align: center">
              <strong style="color: gray;">{{ventactivo?"VENTA COBRADA":"TOTAL A COBRAR"}}</strong>
                <p style="font-size: 2rem;"><strong>{{formattedTotal(sumaTotal)}}</strong></p>
            </div>
            <div class="col-md-12 text-right">
              <span v-if="ventactivo">Imprimir en:</span>
              <button v-if="ventactivo" class="btn btn-secondary btn-flat tooltip-btn" @click="imprimir(1)" data-tooltip="Impresora"><i class="fas fa-print"></i> </button>&nbsp;
              <button v-if="ventactivo" class="btn btn-primary btn-flat tooltip-btn" @click="imprimir(2)" data-tooltip="Ticketera"> <i class="fas fa-box-tissue"></i></button>
              
              <button v-else class="btn btn-success btn-lg btn-block mt-0" @click="cobrar()"><i class="fas fa-hand-point-up"></i> Cobrar</button>
            </div>
        </div>   
      </div>

    </div>

  </div>
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Cobrando...</span>
        </div>
        <p class="text-light mt-3">Procesando venta, espere...</p>
    </div>

</div><!-- /.card -->

<!-- Modal personalizado -->
<div v-if="showModal" class="my-modal-overlay">

    <div class="my-modal">
  
      <div class="my-modal-header">
        <h3>Imprimir Comprobante en:</h3>
        <button class="my-close-btn" @click="closeModal">×</button>
      </div>
      <div class="my-modal-body">
        <div class="my-button-row">
            <button class="my-btn secondary" @click="imprimir(1)">
                <i class="fas fa-print"></i> Impresora
              </button>

          <button class="my-btn primary" @click="imprimir(2)">
            <i class="fas fa-box-tissue"></i> Ticketera
          </button>
        </div>
      </div>
  
      <div class="my-modal-footer">
        <button class="my-btn danger" @click="closeModal">Cerrar</button>
      </div>  
    </div>
  </div>
<!-- FIN Modal -->

</template>
<script>
    import { ref, onMounted } from 'vue' //sobre fechas
    import { DateTime } from 'luxon' //timezone manejo
    export default{
      setup() {
        const fechaBuscar = ref('');
        onMounted(() => {
          const today = DateTime.now().setZone('America/Lima');
          fechaBuscar.value = today.toISODate();
        });
        return {
          fechaBuscar,
        };
      },
      data(){
          return{
            idPedido:'',
            arrayPedido: [],
            arrayDetalle: [],
            arraymetodopago:[],
            arrayError:[],
            cliente:'',
            cliente_doc:'',
            usuario:'',
            comprobante:'',
            numPedido:'',
            fechaPedido:'',
            idComprob:'',
            subtotal:'',
            igvTotal:'',
            moneda:'',

            numComprobante:'',
            ventactivo:'',
            idVenta:'',
            serie:'',
            metpago:0,
            numBuscar:'',
            idEmpresa:'',
            rucEmpresa:'',
            
            idUsuario:'',
            idSucursal:'',

            loading:false,
            showModal:false,
          }
      },
      computed: {
     
        sumaTotal(){
          return Number(this.igvTotal) + Number(this.subtotal)
        },
      },
      methods:{
          formattedTotal(amount) {
            return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            }).format(amount);
          },
          listarPedido(pageNumber = 1,fechaBuscar, numBuscar){
            if(this.fechaBuscar=='' || this.numBuscar==''){
                this.$toastr.error('Ingrese una fecha y número','Campos vacíos')
                return
            }
              let me = this
              this.$axios.get(`apiventa/pedidos/?page=${pageNumber}&numero=${numBuscar}&fecha=${fechaBuscar}`)
              .then(function(response){
                me.arrayPedido = response.data.results
                  if(me.arrayPedido.length){
                    if(me.arrayPedido[0]['activo']==0){me.$toastr.error('Este pedido esta anulado','Pedido N. '+me.numBuscar);me.limpiar(); return}
                    me.cliente = me.arrayPedido[0]['cliente']
                    me.cliente_doc = me.arrayPedido[0]['cliente_doc']
                    me.cliente_dir = me.arrayPedido[0]['cliente_dir']
                    me.vendedor = me.arrayPedido[0]['usuario']
                    me.idPedido = me.arrayPedido[0]['id']
                    me.comprobante = me.arrayPedido[0]['comprobante']
                    me.numPedido = me.arrayPedido[0]['numero']
                    me.fechaPedido = me.arrayPedido[0]['fecha']
                    me.idComprob = me.arrayPedido[0]['idComprob']
                    me.subtotal = me.arrayPedido[0]['subtotal']
                    me.dsctoTotal = me.arrayPedido[0]['dsctoTotal']
                    me.igvTotal = me.arrayPedido[0]['igvTotal']
                    me.moneda = me.arrayPedido[0]['moneda']
                    me.metpago = me.arrayPedido[0]['metodoPago']
                    me.listarDetalle()
                    me.listarVenta()
                  }else{me.$toastr.info('No se encontraron datos','Sin registro');me.limpiar()}
              })
          },
          
          listarDetalle(){
            let me = this
            this.$axios.get(`apiventa/detalle/?idPedido=${me.idPedido}`)
              .then(function(response){
                  me.arrayDetalle = response.data
              })
          },
          listarVenta(){
            let me = this
            this.$axios.get(`apiventa/caja/?search=${me.idPedido}`)
              .then(function(response){
                  if(response.data && response.data.length > 0){
                    me.ventactivo = response.data[0]['activo']
                    me.numComprobante = response.data[0]['numComprobante']
                    me.serie = response.data[0]['serie']
                    me.idVenta = response.data[0]['id']
                  }else{
                    me.numComprobante=''
                    me.serie='',
                    me.ventactivo=''
                    me.idVenta=''
                  }
              })
          },
          limpiar(){
            this.cliente=''; this.cliente_doc=''; this.vendedor=''; this.idPedido=''; this.comprobante=''; this.arrayDetalle=[]; this.numPedido='';this.fechaPedido='';
            this.numComprobante=''; this.ventactivo='';this.serie='';this.igv_total=0;this.subtotal=0;
          },
          limpiarTodo(){
            this.cliente=''; this.cliente_doc=''; this.vendedor=''; this.idPedido=''; this.comprobante=''; this.arrayDetalle=[];this.numBuscar=''; this.numPedido='';
            this.fechaPedido='';this.numComprobante=''; this.ventactivo=''; this.serie='';this.igv_total=0;this.subtotal=0;
          },
          fechaFormateada(fecha) {
        // Separar la fecha en partes (año, mes, día)
          const partes = fecha.split('-');

          // Crear una nueva cadena en el formato deseado
          return `${partes[2]}/${partes[1]}/${partes[0]}`;
        },
        validarPago(){
          this.errorPago = 0
          this.arrayError = []
          if(this.metpago == 0) this.arrayError.push("Seleccion un método de pago")
          if(!this.arrayDetalle.length) this.arrayError.push("No hay nada para cobrar")          
          if(this.arrayError.length) this.errorPago = 1
          return this.errorPago
        },
        cobrar(){
            if(this.validarPago()){
                this.arrayError.forEach(element => {
                this.$toastr.error(element,'Atencion!')
                })
                return
            }
          let me = this
          this.$swal.fire({
          title: 'Cobrar venta',
          text: "Esta seguro?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Cobrar'
          }).then((result) => {
            me.loading = true
            if (result.isConfirmed) {
              this.$axios.post(`apiventa/caja/`, { //URL COBRAR VENTA
                  idUsuario: me.idUsuario, //usuario logueado
                  tipComprobante:me.idComprob,
                  observacion:'',
                  idPedido:me.idPedido,
                  metodoPago: me.metpago,
                  numComprobante:'0',
                  serie:'',
                  idSucursal:me.idSucursal,
                  idEmpresa:me.idEmpresa,
                  rucEmpresa: me.rucEmpresa,
              }).
              then((response)=>{
                me.$toastr.success('Venta cobrada', 'Excelente!')
                console.log(response.data)
                me.listarPedido(1,me.fechaBuscar,me.numBuscar)
                //enviando a sunat
                if(response.data.siEnviarSunat === true){
                    me.$toastr.success('Enviando a SUNAT')
                    this.enviarSunat(response.data.nombre_zip)
                }
                //modal para imprimir en tikect o A4
                me.showModal=true
              }).
              catch((error)=>{
                console.error(error)
                if (error.response && error.response.data && error.response.data.error) {
                    me.$toastr.error(error.response.data.error, 'Error');
                } else {
                    me.$toastr.error('Error inesperado al generar XML', 'Error');
                }
              })
              .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
            }else{
                me.loading=false
            }
          })
        },
        imprimir(imp){
          window.open(`/impresiones/comprobante/` + this.idVenta +`/`+imp+`/`+this.idEmpresa, '_blank')
          this.showModal=false
        },
        enviarSunat(nombre_xmlzip){
            if(!nombre_xmlzip){this.$toastr.error('no existe el XML','Error'); return}
            let me = this
            me.$axios.get(`apisunat/enviarsunatxml/?nombre_xmlzip=${nombre_xmlzip}&enviar_sunat=1&idEmpresa=${me.idEmpresa}`)
            .then(function (response) {
                //console.log(response.data.message)
                if(response.data.message == 'success') me.$toastr.success(response.data.mensaje,'Excelente')
                else me.$toastr.error(response.data.mensaje,'Error')
            })
            .catch(function (error) {
              if (error.response) {
                  console.log("Error en backend:", error.response.data);
                  me.$toastr.error(error.response.data.mensaje || 'Error interno', 'Error');
              } else {
                  console.log("Error de red:", error.message);
                  me.$toastr.error('Error de red o servidor '+ error.message, 'Error');
              }
            });
        },
        closeModal() {
            this.showModal = false;
        }
      },
          
      watch: {
   
      },
      mounted(){
        this.idUsuario = localStorage.getItem('idusuario')
        this.idSucursal = localStorage.getItem('idSucursal')
        this.arraymetodopago = ['EFECTIVO','YAPE','PLIN','TARJETA DEBITO']
        this.idEmpresa = localStorage.getItem('idEmpresa')
        this.rucEmpresa = localStorage.getItem('rucEmpresa')

        const pedido = this.$route.query.pedido
        const fecha = this.$route.query.fecha
        if(pedido) this.numBuscar = pedido
        if(fecha) this.fechaBuscar = fecha
        if(pedido && fecha){
            this.listarPedido(1,this.fechaBuscar,this.numBuscar)
        }
      }
  }
</script>

<style scoped>
/* Fondo oscuro + blur */
.my-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: flex-start; /* <-- lo sube */
  padding-top: 200px;   
  z-index: 9999;
}

/* Caja del modal */
.my-modal {
  background: #fff;
  width: 420px;
  border-radius: 10px;
  padding: 0;
  box-shadow: 0 5px 20px rgba(0,0,0,0.25);
  animation: fadeIn 0.25s ease;
}

/* Header */
.my-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.my-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

/* Botón cerrar */
.my-close-btn {
  border: none;
  background: none;
  font-size: 22px;
  cursor: pointer;
  padding: 0;
}

/* Cuerpo */
.my-modal-body {
  padding: 20px;
  text-align: center;
  font-size: 16px;
}

.my-button-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 0px;
}

/* Footer */
.my-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: right;
}

/* Botones */
.my-btn {
  flex: 1;
  padding: 10px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: 0.2s;
}

.my-btn.primary {
  background: #007bff;
  color: white;
}

.my-btn.primary:hover {
  background: #0064d3;
}

.my-btn.secondary {
  background: #6c757d;
  color: white;
}

.my-btn.secondary:hover {
  background: #565e64;
}

.my-btn.danger {
  background: #dc3545;
  color: white;
}

.my-btn.danger:hover {
  background: #b92a37;
}

/* Animación */
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9);}
  to { opacity: 1; transform: scale(1);}
}

</style>